// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "pre[data-v-3bcae447]{font-family:Vazir,serif!important;white-space:break-spaces;overflow:hidden}a.link-tag[data-v-3bcae447]{color:inherit!important;text-decoration:none}", ""]);
// Exports
module.exports = exports;
